<script>
  export default {
    props: ['relatorio', 'configuracao', 'projeto', 'filtros'],
    methods: {
      saldo(saldoAnterior, indiceSubrubrica, indiceLancamento) {
        return saldoAnterior + this.relatorio[indiceSubrubrica].lancamentos.reduce((total, lancamento, i) => {
          if (i > indiceLancamento) return total;

          if (lancamento.creditoDebito === 1) {
            return total + lancamento.valor;
          } else {
            return total - lancamento.valor;
          }
        }, 0);
      }
    }
  }
</script>

<template>
  <div class="col-md-12">
    <div class="ibox float-e-margins">
      <div class="ibox-content">

        <div class="table-responsive">
          <table class="table table-condensed no-margins">
            <thead>
            <tr>
              <th>Projeto</th>
              <th class="text-right">Período</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ projeto.nomeProjeto}}</td>
              <td class="text-right no-border-left">{{ filtros.dataInicio +' - '+ filtros.dataFim}}</td>
            </tr>
            </tbody>
          </table>

          <table class="table relatorio table-bordered no-margin-bottom" v-for="(subrubrica, indiceSubrubrica) in relatorio">
            <thead>
            <tr>
              <th class="no-border-right" colspan="5">Subrubrica</th>
              <th class="text-right no-border-left" style="width: 200px">Saldo anterior</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="no-border-right" colspan="5">{{ subrubrica.descricao }}</td>
              <td class="text-right no-border-left">{{ subrubrica.saldoAnterior | formatarNumero }}</td>
            </tr>
            <tr>
              <td class="text-right no-border-right" colspan="5" ><b>Crédito: {{ subrubrica.valorCredito | formatarNumero }}</b></td>
              <td class="text-right no-border-left"><b>Débito: {{ subrubrica.valorDebito | formatarNumero }}</b></td>
            </tr>
            <tr>
              <td><b>Data</b></td>
              <td><b>Histórico</b></td>
              <td><b>Documento</b></td>
              <td class="text-center" style="width: 100px"><b>C/D</b></td>
              <td class="text-right"><b>Valor</b></td>
              <td class="text-right"><b>Saldo</b></td>
            </tr>
            <tr v-for="(lancamento, indiceLancamento) in subrubrica.lancamentos">
              <td>{{ lancamento.data | formatarData }}</td>
              <td>{{ `${lancamento.historico} - ${subrubrica.descricao} - ${lancamento.complemento}` }}</td>
              <td>{{ lancamento.documento }}</td>
              <td class="text-center" :class="[lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ lancamento.creditoDebito === 1 ? 'C' : 'D' }}</td>
              <td class="text-right" :class="[lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ lancamento.valor | formatarNumero }}</td>
              <td class="text-right" :class="[saldo(subrubrica.saldoAnterior, indiceSubrubrica, indiceLancamento) >= 0 ? 'text-primary' : 'text-danger']">
                {{ saldo(subrubrica.saldoAnterior, indiceSubrubrica, indiceLancamento) | formatarNumero }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Subrubricas/Analitico.vue